export default __webpack_public_path__ + "static/blob8-1a9774823019fc2f3bc074adc9aba9b2.svg";